import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch, useSelector } from 'react-redux'
import { faAngleRight, faAngleLeft, faAnglesRight, faAnglesLeft } from '@fortawesome/free-solid-svg-icons'
import { setPage, setItemPerPage, selectPage, selectItemPerPage, nextPage, previousPage } from '../slice/itemSlice.js'
import { ToggleButton, ToggleButtonGroup, Row, Col } from 'react-bootstrap'

const Pagination = ({items}) => {

  const dispatch = useDispatch();

  const currentPage = useSelector(selectPage);
  const iPP = useSelector(selectItemPerPage);
  const [pageNumsArr, setPageNumsArray] = useState([])
  const [shownArr, setShownArr] = useState([])

  useEffect(() => {
    const div = items.length / iPP;
    const rem = items.length % iPP;
    let pages = [];

    if (div <= 1) pages = [1]
    else {
      if(rem > 0) {
        for (let i = 1; i <= div+1; i++) {
          pages.push(i)
        }
      } else {
        for (let i = 1; i <= div; i++) {
          pages.push(i)
        }
      } 
    }    
    setPageNumsArray(pages)

  }, [iPP, items])

  useEffect(() => {
    let arr = [];
    if(pageNumsArr.length <= 3) {
      for(let i = 1; i <= pageNumsArr.length; i++) {
        arr.push(i)
      }
    } else {
      if(currentPage ===  1) {
        arr = [ 1, 2 , 3]
      } else {
        arr = pageNumsArr.slice(currentPage-2,currentPage+1)
      }
    }


    if(arr[0] > 1) arr.unshift("...")
    if(arr[arr.length-1] < pageNumsArr[pageNumsArr.length-1]) {
      arr.push("...")
    }

    setShownArr(arr)
  }, [pageNumsArr, currentPage])


  return (
      <Row className='gy-2 my-5'>
        <Col lg={6} md={12}>
          <div className='d-flex justify-content-lg-start justify-content-md-center justify-content-sm-center'>
            <ToggleButtonGroup type="radio" name="options" >
              <ToggleButton variant="outline-dark" onClick={() => dispatch(setPage(1))} value={1}>
                <FontAwesomeIcon icon={faAnglesLeft} />
              </ToggleButton>
              <ToggleButton variant="outline-dark" disabled={currentPage === 1} onClick={() => dispatch(previousPage())} value={""}>
                <FontAwesomeIcon className='' icon={faAngleLeft} />
              </ToggleButton>

              {shownArr.map(n => <ToggleButton key={n} variant={n===currentPage ? "dark" : "outline-dark"} onClick={() => dispatch(setPage(n))} disabled={n==="..."} value={n}>{n}</ToggleButton>)}

              <ToggleButton variant="outline-dark" disabled={currentPage === pageNumsArr.length} onClick={() => dispatch(nextPage())} value={""}>
                <FontAwesomeIcon className='' icon={faAngleRight} />
                </ToggleButton>
              <ToggleButton variant="outline-dark" onClick={() => dispatch(setPage(pageNumsArr[pageNumsArr.length-1]))} value={""}>
                <FontAwesomeIcon className='' icon={faAnglesRight} />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </Col>

        <Col lg={6} md={12}>
          <div className='d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center'>
            <ToggleButtonGroup type="radio" name="options">
              <ToggleButton variant={12===iPP ? "dark" : "outline-dark"} onClick={e => dispatch(setItemPerPage(12))} value={12}>12</ToggleButton>
              <ToggleButton variant={8===iPP ? "dark" : "outline-dark"} onClick={e => dispatch(setItemPerPage(8))} value={8}>8</ToggleButton>
              <ToggleButton variant={4===iPP ? "dark" : "outline-dark"} onClick={e => dispatch(setItemPerPage(4))} value={4}>4</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </Col>
      </Row>
  ) 
}

export default Pagination